<template lang="html">
  <div>
    <v-form ref="form" lazy-validation autocomplete="off">
      <v-card-title primary-title class="card-header">
        {{ $t('title.resumo') }}
        <v-spacer />
        <tooltip-ajuda :mensagem="`${$t('message.ajuda.parametrizacao_acao.resumo')}`" />
      </v-card-title>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              id="config_acao_nome"
              v-model="parametrizacao.nome"
              :label="`${$tc('label.nome', 1)} * `"
              :rules="[rules.required]"
              maxlength="50"
              counter=50
              required>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="8">
            <v-text-field
              id="config_acao_descricao"
              v-model="parametrizacao.descricao"
              :label="`${$tc('label.descricao', 1)} * `"
              :rules="[rules.required]"
              maxlength="200"
              counter=200
              required>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              id="config_acao_categoria"
              v-model="parametrizacao.categoriaAcao"
              :label="$tc('label.categoria_acao', 1)"
              maxlength="50"
              counter=50>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              id="config_acao_fluxo_trade"
              class="Form-text__invalid"
              name="forma_rateio"
              item-text="text"
              item-value="value"
              v-model="parametrizacao.fluxo"
              :items="fluxos"
              :rules="[rules.required]"
              :label="`${$tc('label.fluxo_trademarketing', 1)} *`"
              required
              @change="selecionaFluxo">
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-switch
              color="primary"
              id="config_acao_ativar_inativar"
              :label="`${$t('label.ativo')}`"
              v-model="parametrizacao.indAtivo"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-switch
              color="primary"
              id="config_acao_exclusivo_contrato"
              :label="`${$t('label.habilitar_uso_exclusivo_contrato')}`"
              v-model="parametrizacao.indExclusivoContrato"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-switch
              @change="alteracaoAcaoProjeto"
              color="primary"
              id="config_acao_projeto"
              :label="`${$t('label.habilitar_acao_projeto')}`"
              v-model="parametrizacao.indAcaoProjeto"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-switch
              :disabled="!parametrizacao.indAcaoProjeto"
              color="primary"
              id="config_acao_projeto_obrigatorio"
              :label="`${$t('label.habilitar_acao_projeto_obrigatorio')}`"
              v-model="parametrizacao.indAcaoProjetoObrigatorio"/>
          </v-col>
        </v-row>
      </v-container>
      <v-card-title primary-title class="card-header">
        {{ $t('title.upload_arquivo') }}
        <v-spacer />
        <tooltip-ajuda :mensagem="`${$t('message.ajuda.parametrizacao_acao.upload')}`" />
      </v-card-title>
      <v-container fluid>
          <v-col cols="12" sm="12" class="pb-0">
            <v-switch
              id="config_acao_upload_obrigatorio"
              :label="$tc('label.upload_arquivo_obrigatorio_aprovacao', 1)"
              @change="alteracaoUploadObrigatorio"
              v-model="parametrizacao.uploadObrigatorio"
            ></v-switch>
          </v-col>
        <v-subheader class="mt-0">{{ $tc('label.status_permitidos', 1) }}</v-subheader>
        <v-row class="mx-4">
          <v-col cols="2">
            <v-checkbox
              v-model="parametrizacao.statusPermitidosUploadPlanejamento.emCadastro"
              :disabled="parametrizacao.uploadObrigatorio"
              class="mx-2"
              :label="$tc('status_entidade.em_cadastro')">
            </v-checkbox>
          </v-col>
          <v-col cols="10">
            <v-checkbox
              v-model="parametrizacao.statusPermitidosUploadPlanejamento.aprovado"
              class="mx-2"
              :label="$tc('status_entidade.aprovado')">
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row class="mx-4">
          <v-col cols="2">
            <v-checkbox
              v-model="parametrizacao.statusPermitidosUploadPlanejamento.aguardandoAprovacao"
              class="mx-2"
              :label="$tc('status_entidade.aguardando_aprovacao')">
            </v-checkbox>
          </v-col>
          <v-col cols="10">
            <v-checkbox
              v-model="parametrizacao.statusPermitidosUploadPlanejamento.reprovado"
              class="mx-2"
              :label="$tc('status_entidade.reprovado')">
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row class="mx-4">
          <v-col cols="2">
            <v-checkbox
              v-model="parametrizacao.statusPermitidosUploadPlanejamento.emAnalise"
              class="mx-2"
              :label="$tc('status_entidade.em_analise')">
            </v-checkbox>
          </v-col>
          <v-col cols="10">
            <v-checkbox
              v-model="parametrizacao.statusPermitidosUploadPlanejamento.cancelado"
              class="mx-2"
              :label="$tc('status_entidade.cancelado')">
            </v-checkbox>
          </v-col>
        </v-row>
      </v-container>

      <div v-if="!modoVarejo">
        <v-card-title primary-title class="card-header mt-4">
          {{ $tc('label.conta_corrente', 1) }}
          <v-spacer />
          <tooltip-ajuda :mensagem="`${$t('message.ajuda.parametrizacao_acao.tipo_investimento')}`" />
        </v-card-title>
        <v-row>
          <v-col cols="4">
           <v-switch class="ml-2 " v-model="parametrizacao.indHabilitaContaCorrenteUnica" :label="$t('label.habilitar_unica_conta_corrente_acao')" />
           <br>
           <v-switch v-if="id === 91" class="ml-2 " v-model="parametrizacao.indBloqueioVerbaImc" :label="$t('label.bloqueio_verba_imc')" />
          </v-col>
        </v-row>
        <v-data-table :headers="headersTipoInvestimento"
          id="config_acao_tabela_tipo_investimento"
          :items="tipos"
          hide-default-footer
          disable-pagination
          :items-per-page="-1"
          :no-data-text="$t('message.nenhum_registro')">
          <template v-slot:item.habilita="{ item }">
            <v-switch hide-default-footer
                v-model="item.habilita" />
          </template>
          <template v-slot:item.operacao="{ item }">
            <v-radio-group v-model="item.operacao" row v-if="item.habilita" hide-default-footer>
                <v-radio v-if="contexto.value" v-for="(contexto, indice) in operacoes" class="margem"
                  :label="contexto.text" :value="contexto.value" v-bind:key="indice"/>
              </v-radio-group>
          </template>
        </v-data-table>
      </div>

      <v-row justify="end" class="my-4">
        <v-btn id="config_acao_passo1_botao_cancelar" @click="cancelar" class="mr-3">{{ $t('label.cancelar') }}</v-btn>
        <v-btn id="config_acao_passo1_botao_proximo" color="primary" @click="proximoPasso" class="mr-3">{{ $t('label.proximo_passo') }}</v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script type="text/javascript">
import Passo1 from './Passo1';
import TooltipAjuda from '../TooltipAjuda';

export default {
  name: 'ParametrizacaoAcaoPasso1',
  props: {
    id: Number,
    modoVarejo: Boolean,
  },
  components: {
    TooltipAjuda,
  },
  watch: {
    id() {
      this.prepararPasso();
    },
  },
  data() {
    return {
      paramOrcamentoResources: this.$api.parametrizacaoOrcamento(this.$resource),
      paramAcaoResources: this.$api.parametrizacaoAcao(this.$resource),

      passo: 1,
      headersTipoInvestimento: [
        { text: this.$tc('label.tipo_verba', 1), value: 'tipoVerba', width: '25%' },
        { text: this.$tc('label.tipo_investimento', 1), value: 'tipoInvestimento', width: '25%' },
        { text: this.$tc('label.habilita', 1), value: 'habilita', width: '20%' },
        { text: this.$tc('label.operacao', 1), value: 'operacao', width: '30%' },
      ],
      tipos: [],
      fluxos: [
        {
          text:
            `${this.$tc('label.planejamento', 1)} -> ${this.$tc('label.apuracao', 1)} -> ${this.$tc('label.liquidacao', 1)}`,
          value: 'PLANEJAMENTO,APURACAO,LIQUIDACAO',
          indApuracao: true,
        },
        {
          text:
            `${this.$tc('label.planejamento', 1)} -> ${this.$tc('label.liquidacao', 1)}`,
          value: 'PLANEJAMENTO,LIQUIDACAO',
        },
        {
          text:
            `${this.$tc('label.planejamento', 1)} -> ${this.$tc('label.apuracao', 1)} + ${this.$tc('label.liquidacao', 1)}`,
          value: 'PLANEJAMENTO,APURACAO_E_LIQUIDACAO',
          indApuracao: true,
        },
        {
          text:
            `${this.$tc('label.planejamento', 1)} -> ${this.$tc('label.apuracao', 1)} -> ${this.$tc('label.orcamento', 1)}`,
          value: 'PLANEJAMENTO,APURACAO,ORCAMENTO',
          indApuracao: true,
        },
        {
          text:
            `${this.$tc('label.planejamento', 1)} -> ${this.$tc('label.cotacao', 1)} -> ${this.$tc('label.liquidacao', 1)}`,
          value: 'PLANEJAMENTO,COTACAO,LIQUIDACAO',
        },
        {
          text: `${this.$tc('label.planejamento', 1)}`,
          value: 'PLANEJAMENTO',
        },
      ],
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
      parametrizacao: new Passo1(),
      operacoes: [
        { text: this.$tc('label.debito', 1), value: 'DEBITO' },
        { text: this.$tc('label.credito', 1), value: 'CREDITO' },
      ],
    };
  },
  methods: {
    alteracaoUploadObrigatorio() {
      this.parametrizacao
        .statusPermitidosUploadPlanejamento
        .emCadastro = this.parametrizacao.uploadObrigatorio
        || this.parametrizacao.statusPermitidosUploadPlanejamento.emCadastro;
    },
    alteracaoAcaoProjeto() {
      if (!this.parametrizacao.indAcaoProjeto) {
        this.parametrizacao.indAcaoProjetoObrigatorio = false;
      }
    },
    adicionarTiposInvestimento() {
      const tiposSelecionados = this.tipos.filter((a) => a.habilita);
      if (tiposSelecionados.length) {
        this.parametrizacao.investimentos = tiposSelecionados;
      } else {
        this.parametrizacao.investimentos = [];
      }
      return true;
    },
    buscarTiposInvestimento() {
      this.paramOrcamentoResources.listarTipoInvestimento().then((response) => {
        this.tipos = response.data;
        if (this.tipos.length) {
          if (this.parametrizacao.investimentos.length) {
            this.tipos.forEach((t) => {
              const sel = this.parametrizacao.investimentos
                .filter((el) => el
                  .id_orcamento_verba_investimento === t.idOrcamentoVerbaInvestimento);
              if (sel.length) {
                t.habilita = true;
                t.operacao = sel[0].operacao;
              } else {
                t.habilita = false;
              }
            });
          }
        }
      })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    cancelar() {
      this.$emit('PARAMETRIZACAO_ACAO_CANCELAR');
    },
    obter(id) {
      this.paramAcaoResources.obterPasso1({ id }, { id }).then((response) => {
        this.parametrizacao = new Passo1(response.data);
        this.buscarTiposInvestimento();
        this.$emit('PARAMETRIZACAO_ACAO_ATUALIZAR_PASSO', this.passo, this.parametrizacao);
        this.$emit('PARAMETRIZACAO_ACAO_DEFINIR_PASSOS');

        this.selecionaFluxo();
      }, (err) => {
        this.$error(this, err);
      });
    },
    prepararPasso() {
      if (this.id) {
        // Editar
        this.obter(this.id);
      } else {
        // Novo
        this.parametrizacao = new Passo1();
        this.buscarTiposInvestimento();
      }
    },
    proximoPasso() {
      if (this.$refs.form.validate() && this.adicionarTiposInvestimento()) {
        this.$emit('PARAMETRIZACAO_ACAO_ATUALIZAR_PASSO', this.passo, this.parametrizacao);
        this.$emit('PARAMETRIZACAO_ACAO_CONTINUAR', this.passo + 1, this.id);
      }
    },
    selecionaFluxo() {
      let indApuracao = false;
      const { fluxo } = this.parametrizacao;
      this.fluxos.forEach((item) => {
        if (item.value === fluxo && item.indApuracao) {
          indApuracao = item.value === fluxo;
        }
      });
      this.parametrizacao.indApuracao = indApuracao;
    },
  },
  mounted() {
    this.prepararPasso();
  },
};
</script>
<style lang="scss">
  @import '~@/config/theme/theme.scss';
  .card-header {
    background-color: $primary-color;
    color: #ffffff;
  }
</style>
